import { cn } from "@/lib/utils";

interface DescriptionProps {
	children: React.ReactNode;
	className?: string;
}

const Description: React.FC<DescriptionProps> = (props) => {
	return <div className={cn("text-xs opacity-80 mt-1", props.className)}>{props.children}</div>;
};

export default Description;
